import React from 'react'
import { Link } from 'react-router-dom'
import { HistoryOutlined } from '@ant-design/icons'
import { Tag } from 'antd'
import { SortOrder } from 'antd/lib/table/interface'

import { Call, TCallLog } from '../../../../context/types'
import { amountToCurrencyFormat } from '../../../../utils/format'

export const columns = (setCallLogs: (callLogs: TCallLog[]) => void) => [
	{
		title: 'User',
		dataIndex: 'user.last_name',
		key: 'user.last_name',
		defaultSortOrder: 'descend' as SortOrder,
		sortDirections: ['descend', 'ascend'] as SortOrder[],
		sorter: () => 0,
		render: (_: any, v: Call) => {
			return (
				<p style={{ display: 'flex', flexDirection: 'column' }}>
					<span>{`${v.user.first_name} ${v.user.last_name}`}</span>
					<span>
						<a href={`mailto:${v.user.email}`}>{v.user.email}</a>
					</span>
					<span>{v.user.timezone}</span>
				</p>
			)
		},
	},
	{
		title: 'Expert',
		dataIndex: 'expert.last_name',
		key: 'expertUser.last_name',
		defaultSortOrder: 'descend' as SortOrder,
		sortDirections: ['descend', 'ascend'] as SortOrder[],
		sorter: () => 0,
		render: (_: any, v: Call) => {
			return (
				<p style={{ display: 'flex', flexDirection: 'column' }}>
					<span>
						<Link
							to={`/expert/${v.expert.expert_slug}`}
							target="_blank"
						>{`${v.expert.first_name} ${v.expert.last_name}`}</Link>
					</span>
					<span>
						<a href={`mailto:${v.expert.email}`}>{v.expert.email}</a>
					</span>
					<span>{v.expert.timezone}</span>
				</p>
			)
		},
	},
	{
		title: 'At',
		dataIndex: 'start_time',
		key: 'call.start_time',
		defaultSortOrder: 'descend' as SortOrder,
		sortDirections: ['descend', 'ascend'] as SortOrder[],
		sorter: () => 0,
		render: (start_time: any, call: Call) => {
			const setLogs = () => !call.status?.upcoming && setCallLogs(call.callLogs || [])

			return (
				<div style={{ display: 'flex', alignItems: 'center' }}>
					<span>{new Date(start_time).toLocaleString()}</span>
					<HistoryOutlined style={{ fontSize: 20, marginLeft: 14, cursor: 'pointer' }} onClick={setLogs} />
				</div>
			)
		},
	},
	{
		title: 'Brand',
		dataIndex: 'brand',
		key: 'brand.name',
		defaultSortOrder: 'descend' as SortOrder,
		sortDirections: ['descend', 'ascend'] as SortOrder[],
		sorter: () => 0,
		render: (brand: any) => {
			return <span>{brand}</span>
		},
	},
	{
		title: 'Channel',
		dataIndex: 'channel',
		key: 'channel.name',
		defaultSortOrder: 'descend' as SortOrder,
		sortDirections: ['descend', 'ascend'] as SortOrder[],
		sorter: () => 0,
		render: (channel?: string) => {
			return channel ? (
				<span>{channel}</span>
			) : (
				<Tag color="#f5f5f5" style={{ color: '#595959', borderColor: '#595959' }}>
					{'NA'}
				</Tag>
			)
		},
	},
	{
		title: 'CTU',
		dataIndex: 'cost_to_user',
		key: 'callPricing.cost_to_user',
		defaultSortOrder: 'descend' as SortOrder,
		sortDirections: ['descend', 'ascend'] as SortOrder[],
		sorter: () => 0,
		render: (cost_to_user: any) => {
			return <span>${amountToCurrencyFormat(cost_to_user)}</span>
		},
	},
	{
		title: 'Coupon',
		dataIndex: 'coupon_code',
		key: 'coupon_code',
		render: (coupon_code: any) => {
			return <span>{coupon_code || 'None'}</span>
		},
	},
	{
		title: 'FTE',
		dataIndex: 'fee_to_expert',
		key: 'callPricing.fee_to_expert',
		defaultSortOrder: 'descend' as SortOrder,
		sortDirections: ['descend', 'ascend'] as SortOrder[],
		sorter: () => 0,
		render: (fee_to_expert: any, v: Call) => {
			const fee = fee_to_expert || v.fee_to_charity
			return (
				<span>
					${amountToCurrencyFormat(fee)}
					{`${v.fee_to_charity ? ' (charity)' : ''}`}
				</span>
			)
		},
	},
	{
		title: 'CTC',
		dataIndex: 'cost_to_channel',
		key: 'callPricing.cost_to_channel',
		defaultSortOrder: 'descend' as SortOrder,
		sortDirections: ['descend', 'ascend'] as SortOrder[],
		sorter: () => 0,
		render: (cost_to_channel: any) => {
			return <span>${amountToCurrencyFormat(cost_to_channel)}</span>
		},
	},
]
